/**
 * TON Backend API Service
 */
import axios from 'axios';
import { getApiUrl } from '../utils/api';

const API_URL = getApiUrl();

const tonApi = axios.create({
  baseURL: `${API_URL}/api/ton`,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const tonService = {
  /**
   * Generate new TON wallet
   * @param {string} userId - User ID
   * @returns {Promise<Object>} Wallet data
   */
  async generateWallet(userId) {
    try {
      const response = await tonApi.post('/wallets/generate', {
        user_id: userId,
      });
      return response.data;
    } catch (error) {
      console.error('Error generating wallet:', error);
      throw error;
    }
  },

  /**
   * Import existing TON wallet
   * @param {string} userId - User ID
   * @param {string} mnemonic - 24-word mnemonic
   * @returns {Promise<Object>} Wallet data
   */
  async importWallet(userId, mnemonic) {
    try {
      const response = await tonApi.post('/wallets/import', {
        user_id: userId,
        mnemonic: mnemonic,
      });
      return response.data;
    } catch (error) {
      console.error('Error importing wallet:', error);
      throw error;
    }
  },

  /**
   * Get wallet balance
   * @param {string} address - TON wallet address
   * @returns {Promise<Object>} Balance data
   */
  async getBalance(address) {
    try {
      const response = await tonApi.get(`/wallets/${address}/balance`);
      return response.data;
    } catch (error) {
      console.error('Error getting balance:', error);
      throw error;
    }
  },

  /**
   * Get wallet transactions
   * @param {string} address - TON wallet address
   * @param {number} limit - Number of transactions
   * @returns {Promise<Array>} List of transactions
   */
  async getTransactions(address, limit = 10) {
    try {
      const response = await tonApi.get(`/wallets/${address}/transactions`, {
        params: { limit },
      });
      return response.data;
    } catch (error) {
      console.error('Error getting transactions:', error);
      throw error;
    }
  },

  /**
   * Check TON service health
   * @returns {Promise<Object>} Health status
   */
  async healthCheck() {
    try {
      const response = await tonApi.get('/health');
      return response.data;
    } catch (error) {
      console.error('Error checking health:', error);
      throw error;
    }
  },
};

export default tonService;
